<ng-container *ngIf="FormControl && FormControl.invalid">
    <i *ngIf="FormControl.errors?.['required']" class="star">
        <mat-icon>
            emergency</mat-icon>
    </i>

    <span *ngIf="!FormControl.errors?.['required']">
        <mat-icon [matTooltip]="getErrorMessage(FormControl)||''">error_outline</mat-icon>
    </span>

</ng-container>